import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function UnderlineIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "10"}
      height={height || "14"}
      viewBox="0 0 10 14"
    >
      <path
        id="Path_10405"
        data-name="Path 10405"
        d="M2.918-11.98v6.822a4.29,4.29,0,0,0,.974,3.091,3.545,3.545,0,0,0,2.667,1,3.5,3.5,0,0,0,2.648-.993,4.341,4.341,0,0,0,.955-3.1V-11.98H11.54v6.8a5.346,5.346,0,0,1-1.388,4.014A4.973,4.973,0,0,1,6.54.18,4.973,4.973,0,0,1,2.928-1.165,5.346,5.346,0,0,1,1.54-5.178v-6.8Z"
        transform="translate(-1.54 11.98)"
        fill={color || "#333"}
      />
      <rect
        id="Rectangle_1923"
        data-name="Rectangle 1923"
        width="10"
        height="1"
        transform="translate(0 13)"
        fill={color || "#333"}
      />
    </svg>
  );
}
